module.exports = __webpack_public_path__ + "static/media/mc.23abdb12.png";